import { HTMLProps } from "react";
import cn from "classnames";
import { useInPageContext } from "../in-page-context";

export type InPageHeaderProps = HTMLProps<HTMLHeadingElement>;

const InPageHeader = ({ children, className, ...rest }: InPageHeaderProps) => {
  const { getBlocksWith } = useInPageContext();

  return (
    <h2 {...rest} className={cn(className, getBlocksWith("__header"))}>
      {children}
    </h2>
  );
};

export default InPageHeader;
